import React from 'react';
import Box from '@bit/knotchinc.web-react-components.box';
import { UserEntityBadge } from 'components/Global/Badges/';
import Tag from 'components/Global/Tag/Tag.jsx';
import { numberWithCommas } from 'helpers/Utils.js';
import { LeaderboardSection, SharedInfo, StyledSharedIcon, Badge, Value, ValueContainer, ValueDesc } from './styled.js';

const validateKeywordData = data => !!(data.keyword && data.keyword.value && data.num_contents);

const KeywordLeaderboardBlock = ({ data = {}, position, reportType }) => {
  const { keyword = {}, num_in_common, num_contents } = data;
  const validatedData = validateKeywordData(data);

  if (!validatedData) {
    return (
      <LeaderboardSection noData>
        <Box height="100px" pt="35px" pl="31px">
          <Tag data={keyword || 'Keyword'}>{position === 0 ? <UserEntityBadge /> : <Badge>{position}</Badge>}</Tag>
          <ValueContainer>
            <Value>--</Value>
            <ValueDesc>Content Pieces</ValueDesc>
          </ValueContainer>
        </Box>
        {position === 0 ? (
          <SharedInfo>No results found for your keyword</SharedInfo>
        ) : (
          <SharedInfo>No results found</SharedInfo>
        )}
      </LeaderboardSection>
    );
  }

  return (
    <LeaderboardSection>
      <Box height="100px" pt="35px" pl="31px">
        <Tag data={keyword}>{position === 0 ? <UserEntityBadge /> : <Badge>{position}</Badge>}</Tag>
        <ValueContainer>
          <Value>{numberWithCommas(num_contents)}</Value>
          <ValueDesc>Content Pieces</ValueDesc>
        </ValueContainer>
      </Box>
      {position === 0 ? (
        <SharedInfo>Your top mentioned Keyword</SharedInfo>
      ) : (
        <SharedInfo>
          <StyledSharedIcon />
          Shared amongst <span>{num_in_common}</span> {`${reportType}s`}
        </SharedInfo>
      )}
    </LeaderboardSection>
  );
};

export default KeywordLeaderboardBlock;
